<template>
  <div class="home">
    <vs-breadcrumb
        :items="bread"
    ></vs-breadcrumb>

    <div class="cattitle">
      Projects
    </div>

    <vs-row vs-w="12">
      <vs-col vs-w="6" vs-sm="12" v-for="ser in items" v-bind:key="ser.index">
        <div class="service-container">
          <div class="img-container"><vs-image :src="ser.img" /></div>
          <div>
            <div class="ser-title">
              <div v-if="$i18n.locale === 'en'">
                {{ ser.title_en }}
              </div>
              <div v-else>
                {{ ser.title_tr }}
              </div>
            </div>
            <div class="ser-descr">
              <div v-if="$i18n.locale === 'en'">
                {{ ser.descr_en }}
              </div>
              <div v-else>
                {{ ser.descr_tr }}
              </div>
            </div>
          </div>
        </div>
      </vs-col>

    </vs-row>


  </div>
</template>

<script>
// @ is an alias to /src

import {__HTTP} from "@/utils";

export default {
  name: 'Projects',
  watch: {
  },
  methods: {
    loadProjects() {
      let requestBody = JSON.stringify({
        get: "posts",
        category: 3,
        withoutLimit: true
      });
      __HTTP("?do=list",requestBody,null,res => {
        this.items = res.data;
      });
    },
  },
  mounted() {
    this.loadProjects();
  },
  data() {
    return {
      bread: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Projects',
              url: '/projects',
              active: true
            }
      ],
      items: [],
    }
  },
  components: {}
}
</script>

<style scoped>
.img-container {
  width: 100%;
}

.img-container img {
  width: 100%;
}
.ser-title {
  font-size: 2rem;
  color: black;
  font-weight: bold;
}

.ser-descr {
  font-size: 1.2rem;
  color: #2c3e50;
}
  .service-container {
    padding: 24px;
    margin: 20px;
    border: 1px solid #f3f3f3;
    margin-bottom: 10px;
    box-shadow: 0px 10px 29px -20px rgba(0,0,0,0.75);
  }
</style>
